module.exports = __webpack_public_path__ + "static/media/Subtract 5.f8f1584f.png";